'use strict';

/* globals window, require, $, utils */

$(window).on('action:ajaxify.end', function (event, data) {
	require(['group-container', 'site-widget'], function (groupContainer, siteWidget) {
		groupContainer.getDetails(data.tpl_url);
		siteWidget.applySiteWidget(data);
	});

	centerCoverOnMobiles(data.tpl_url);
});

function centerCoverOnMobiles(tplUrl) {
	if (utils.isMobile() && $.inArray(tplUrl, ['groups/details', 'groups/settings-page', 'organizations/details']) >= 0) {
		$('.group-cover').css('background-position', '50% 50%');
	}
}
